import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import ShortEssayOption from './ShortEssayOption';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class AggregateShortEssaySectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        shortEssayDataSource: PropTypes.array,
        getFormValue: PropTypes.func,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, shortEssayDataSource, getFormValue, isGlobalSectionItem } = this.props;
        return (
            <div className={'col-12 ase-section-item'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readyOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <FieldArray
                    name={memberReference ? `${memberReference}.content.items` : 'content.items'}
                    shortEssayDataSource={shortEssayDataSource}
                    getFormValue={getFormValue}
                    component={ShortEssayOption}
                    disabled={isGlobalSectionItem}
                />
            </div>
        );
    }
}

export default AggregateShortEssaySectionItem;
